import React, { useContext } from 'react';
import { Button, KIND } from 'baseui/button';
import { CategoricalColumn, CustomColumn, StringColumn } from 'baseui/data-table';
import { DrawerContext } from 'commons-ui';
import _startsWith from 'lodash/startsWith';
import _get from 'lodash/get';
import { StyledLink } from 'baseui/link';
import { UserV2 } from 'models/settingsV2.model';
import UserPermissionsDetails from '../userPermissionsDetails';

export const COL_NAMES = {
	userName: 'name',
	email: 'email',
	phoneNo: 'phone',
	department: 'department',
	manager: 'manager',
	designation: 'designation',
	team: 'team',
	updatedBy: 'updatedBy',
	permissionsInfo: 'permissionsInfo'
};

export const columnConfigs = [
	CustomColumn({
		title: 'User Name',
		maxWidth: 300,
		mapDataToValue: (data: UserV2) => {
			return {
				userName: String(_get(data, COL_NAMES.userName, 'NA')),
				userPermissionsData: data.permissionsInfo || []
			};
		},
		renderCell: (params: any) => {
			const { value } = params;

			const { setDrawerConfig } = useContext(DrawerContext);
			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				setDrawerConfig({
					isOpen: true,
					content: <UserPermissionsDetails userPermissionsData={value.userPermissionsData} />
				});
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{value.userName}</StyledLink>
				</Button>
			);
		},
		textQueryFilter: (textQuery: String, data: any): boolean => {
			return _startsWith(data.userName, `${textQuery}`);
		}
	}),
	StringColumn({
		title: 'Email ID',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.email, 'NA'));
		}
	}),
	StringColumn({
		title: 'Phone No.',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.phoneNo, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Deparment Name',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.department, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Manager Name',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.manager, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'Designation',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.designation, 'NA'));
		}
	}),
	CategoricalColumn({
		title: 'POD/Team',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.team, 'NA'));
		}
	}),
	StringColumn({
		title: 'Updated By',
		mapDataToValue: (data: UserV2) => {
			return String(_get(data, COL_NAMES.updatedBy, 'NA'));
		}
	})
];

export default { columnConfigs, COL_NAMES };
